import Addresses from './Addresses';

export default class CartAddresses extends Addresses {
    cartId: number;

    protected constructor(view: HTMLElement) {
        super(view);
        this.cartId = (this.view.querySelector(this.getSelectorCartId()) ? this.view.querySelector(this.getSelectorCartId()).value : null);
    }

    getSelectorCartId() {
        return 'input[name="currentCart"]';
    }

    updateAddressesView(data: any) {
        if (Object.prototype.hasOwnProperty.call(data, 'templates')) {
            $.each(data.templates, (templateName: string, templateHtml) => {
                if (templateName === 'address-toaster') {
                    toastr.success(templateHtml);
                } else if (templateName.includes('addressItem') || templateName.includes('shippingAddressesList')) {
                    $(`[data-address-template="${templateName}"]`)
                        .empty()
                        .append(templateHtml);
                }
            });
        }
        // Si la requète dispose de données pour la datalayer GTM et que la classe
        // JS de GTM est chargée alors on les transferts
        // @ts-ignore
        if (typeof dataLayer !== 'undefined' && data.gtm !== undefined) {
            // Envoi des données à GTM
            (window as any).dataLayer.push(data.gtm);
            // Object.keys(data.gtm).forEach((k) => {
            //     (window as any).dataLayer.push(data.gtm[k]);
            // });
        }

        if (typeof _mtm !== 'undefined' && data.mtm !== undefined) {
            // Envoi des données à GTM
            Object.keys(data.mtm).forEach((k) => {
                (window as any)._mtm.push(data.mtm[k]);
            });
        }
        this.initEvents();
    }

    initAddressesModal(url: string, loadedCallback: () => any = null) {

        // Surcharge de la callback avec execution, en plus, du rechargement des composants
        const overrideLoadedCallback = () => {
            if (loadedCallback !== null) {
                loadedCallback();
            }
            // Chargement des composants dans le formulaire pour forcer le chargement de ZipCitySelector
            (window as any).Kernel.mountComponents(document.querySelector('#modal-address-form'));
        };

        (window as any).HegydCore.initRemoteModal('#address-modal', url, overrideLoadedCallback,
            // Succès
            (data: any) => {
                setTimeout(() => {
                    this.updateAddressesView(data);
                    (window as any).toastr.success($('#address-modal').data('message-address-updated-success'));
                }, 300);
            },
            // Erreur
            () => {
                setTimeout(() => {
                    (window as any).toastr.error($('#address-modal').data('message-address-updated-error'));
                }, 300);
            });
    }

    initEvents() {
        /* Ajout d'une nouvelle adresse */
        this.addAddressListener();

        /* Edition d'une adresse */
        this.editAddressListener();

        /* Suppression d'une adresse */
        this.deleteAddressListener();
    }

    addAddressListener() {
        const addresses = document.querySelectorAll(this.getSelectorAddAddress());
        if (addresses) {
            addresses.forEach((addAddress) => {
                addAddress.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.initAddressesModal(addAddress.getAttribute('href') ?? '/');
                });
            });
        }
    }

    editAddressListener() {
        const addresses = document.querySelectorAll(this.getSelectorEditAddress());
        if (addresses) {
            addresses.forEach((editAddress) => {
                editAddress.addEventListener('click', async (e) => {
                    e.preventDefault();
                    const response = await fetch(editAddress.getAttribute('href'));
                    if (response.ok) {
                        if (response.status === 200) {
                            this.initAddressesModal(editAddress.getAttribute('href') ?? '/');
                        } else {
                            window.stop();
                        }
                    }
                });
            });
        }
    }

    deleteAddressListener() {
        const addresses = document.querySelectorAll(this.getSelectorDeleteAddress());
        if (addresses) {
            addresses.forEach((deleteAddress) => {
                deleteAddress.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.deleteAddress($(e.target).closest(this.getSelectorDeleteAddress()) as JQuery<HTMLElement>);
                });
            });
        }
    }

    // updateAddressListener() {
    //     const addresses = document.querySelectorAll(this.getSelectorUpdateAddress());
    //     if (addresses) {
    //         addresses.forEach((updateAddress) => {
    //             updateAddress.addEventListener('click', (e) => {
    //                 e.preventDefault();
    //                 this.initAddressesModal(updateAddress.getAttribute('href') ?? '/');
    //             });
    //         });
    //     }
    // }

    hideLoader() {
        $('.loading').hide();
    }

    askToDelete(deleteText: any, buttonText: any, callback: any) {
        (window as any).Swal.fire({
            title: deleteText.title,
            html: deleteText.message,
            allowOutsideClick: true,
            showCancelButton: true,
            closeOnConfirm: false,
            closeOnCancel: true,
            confirmButtonColor: '#ee0000',
            cancelButtonText: buttonText.cancel,
            confirmButtonText: buttonText.confirm,
            showLoaderOnConfirm: true,
            preConfirm() {
                return new Promise((resolve) => {
                    if (callback) {
                        callback(resolve);
                    }
                });
            },
        }).then(() => {
            (window as any).Swal.close();
        });
    }

    deleteAddress($removeCross: JQuery) {
        this.askToDelete($removeCross.data('message'), $removeCross.data('button'), () => {
            (window as any).HegydCore.sendRequest($removeCross.attr('href'), 'DELETE', {}, () => {
                window.location.reload();
            });
        });
    }

    initSelect2Countries() {
        $('#country_id').select2({
            language: 'fr',
            ajax: {
                url: '/countries',
                data(params) {
                    return {
                        query: params.term,
                    };
                },
                processResults(data) {
                    const results = [];
                    $.each(data, (id, entity) => {
                        results.push({
                            id: entity.id,
                            text: entity.title_fr,
                        });
                    });
                    return { results };
                },
                templateResult(data) {
                    return data.title_fr;
                },
            },
            initSelection(element, callback) {
                const id = $('[name=address_country_id]').val();
                const results = [];
                if (id) {
                    $.ajax(`/countries/${id}`, {
                        dataType: 'json',
                    }).done((entity) => {
                        if (entity) {
                            const { id } = entity;
                            const text = entity.title_fr;
                            results.push({ id, text });
                        }
                        callback(results);
                    });
                }
                callback(results);
            },
        });
    }
}
